import axios from 'axios'
import store from '@/store'
import { setupResponseInterceptor } from './responseInterceptor'

const authClient = axios.create({
    baseURL: process.env.VUE_APP_AUTHENTICATION_URL,
    withCredentials: true,
})

authClient.interceptors.request.use(config => {
    config.headers.lang = store.getters['getLang']
    return config;
})

setupResponseInterceptor(authClient)

export default authClient